import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/hero/App';
// import LoaderApp from './components/loader/LoaderApp';
import reportWebVitals from './reportWebVitals';

// ✅ Expose globally for Webflow
window.React = React;
window.ReactDOM = ReactDOM;
window.App = App;

// ❌ Comment out or remove the automatic render (since Webflow handles it)
const root = ReactDOM.createRoot(document.getElementById('bg-interaction'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// const loadRoot = ReactDOM.createRoot(document.getElementById('load-animation'));
// loadRoot.render(
//   <React.StrictMode>
//     <LoaderApp />
//   </React.StrictMode>
// );

reportWebVitals(); 